var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoldStarHalf = function SvgGoldStarHalf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Athlete",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktop-athlete-event-listing-reviews",
    transform: "translate(-785.000000, -1616.000000)",
    fill: "#FFCC00"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(784.000000, 1616.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Star",
    opacity: 0.2,
    points: "10.0249996 13.4700985 4.44724311 16.1900005 5.46643481 10.3465193 1 6.18402993 7.20765163 5.29246195 10.0249996 0 12.8423476 5.29246195 19.0499992 6.18402993 14.5835644 10.3465193 15.6027561 16.1900005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0249996,0 L10.0249996,13.4700985 L4.44724311,16.1900005 L5.46643481,10.3465193 L1,6.18402993 L7.20765163,5.29246195 L10.0249996,0 Z",
    id: "Combined-Shape"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoldStarHalf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gold_star_half.0a22304e.svg";
export { ForwardRef as ReactComponent };